export default __webpack_public_path__ + "static/media/coin-img.5330d062.webp";